import { Component, Input, HostBinding } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { encapsulation } from '../../encapsulation';

@Component({
    selector: 'ubx-accordion-row',
    templateUrl: './accordion-row.component.html',
    host: { class: 'ubx-accordion-row flx f-fd:c' },
    encapsulation,
    animations: [
        trigger('animate', [
            transition(':enter', [
                style({ height: 0 }), animate('0.5s ease', style({ height: '*' }))
            ]),
            transition(':leave', [
                style({ height: '*' }), animate('0.5s ease', style({ height: 0 }))
            ]),
        ]),
    ],
})
export class UBXAccordionRowComponent {
    @Input() heading: string;

    @HostBinding('class.disable') disable = false;
    @HostBinding('class.open') open = false;

    constructor() { }

    toggleRow(value: boolean) {
        this.open = value;
    }
    disableRow(value: boolean) {
        this.disable = value;
    }
}
